import React from 'react'
import Container from 'muicss/lib/react/container'
import ListHeaderNav from './ListHeaderNav'
import FeaturedList from './FeaturedList'

const FeaturedLists = ({ featuredLists }) => (
  <div>
    <div className="list-header --white">
      <Container>
        <ListHeaderNav />
      </Container>
    </div>
    <FeaturedList items={featuredLists} />
  </div>
)

export default FeaturedLists



// WEBPACK FOOTER //
// ./src/components/FeaturedLists.js